import {type SiretLookupResponse, SiretLookupResponseSchema} from "@mytour/shared";
import axios from "axios";

/**
 * Looks up a French company by its 14-digit SIRET via the backend INSEE proxy
 * (#362). The response is a discriminated union: `{found: true, data}` or
 * `{found: false}`. We parse it through the shared Zod schema so a backend
 * contract drift surfaces at the boundary rather than silently downstream.
 *
 * The SIRET is encoded into the path defensively — callers are expected to pass
 * a validated 14-digit string, but encoding keeps a malformed value from
 * breaking out of the path segment.
 */
export const getSiretLookup = async (siret: string): Promise<SiretLookupResponse> => {
  const response = await axios.get<SiretLookupResponse>(
    `api/legal/siret-lookup/${encodeURIComponent(siret)}`
  );
  return SiretLookupResponseSchema.parse(response.data);
};
